import React from "react";
import SubHeading from "../common/SubHeading";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const toxinRatingOptions = [
  { label: "0 - Never", value: "0" },
  { label: "1 - Rarely", value: "1" },
  { label: "2 - Regularly", value: "2" },
  { label: "3 - Often", value: "3" }
];

const toxinQuestions = [
  { key: "nonStickPans", label: "Non-stick pans" },
  { key: "microwave", label: "Microwave" },
  { key: "antiPerspirant", label: "Anti-perspirant" },
  { key: "candles", label: "Candles/incense/home scents" },
  { key: "detergent", label: "Detergent softeners/enhancers" },
  { key: "fakeNails", label: "Fake nails/polish/gel nails" },
  { key: "margarine", label: "Margarine/seed oils" },
  { key: "nonDairyMilks", label: "Non-dairy milks" },
  { key: "aspartame", label: "Splenda/Aspartame" },
  { key: "regularSkinCare", label: "Regular skin care" },
  { key: "bubbleBath", label: "Bubble bath/products" },
  { key: "regularTampons", label: "Regular tampons" },
  { key: "perfume", label: "Perfume/cologne" },
  { key: "processedFoods", label: "Highly processed, packaged foods" },
  { key: "fastFoods", label: "Fast foods" },
  { key: "scentedLotion", label: "Scented body lotion" },
  { key: "selfTanner", label: "Self-tanner" },
  { key: "tapWater", label: "Tap water" },
];

const ToxinScreenSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <section>
      <SubHeading>Toxin Screen</SubHeading>
      <p className="mb-2 text-brand-stone-600">
        What do you consume/use? How often? (0 for never, 1 for rarely, 2 for regularly, 3 for often)
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-8">
        {toxinQuestions.map((q) => (
          <Field
            key={q.key}
            path={`toxinScreen.${q.key}`}
            label={q.label}
            type="radio"
            options={toxinRatingOptions}
          />
        ))}
      </div>
    </section>
  );
};

export default ToxinScreenSectionV2;